import React from 'react'
import _ from 'lodash'
import ArrowForwardOutlined from '@mui/icons-material/ArrowForwardOutlined'
import { store } from 'src/App'
import { dialogContentObj } from 'src/modules/ELearning/components/DialogContent/model'
import { setStep } from 'src/redux/slices/eLearning/enroll'
import { postEnrollCourse } from 'src/services/eLearning/enroll'
import { checkDuplicateData } from 'src/services/eExamination'
import { startLoading, stopLoading } from 'src/redux/slices/loading'
import { closeDialog, openDialog } from 'src/redux/slices/alertDialog'
import { setReduxValue } from 'src/redux/slices/eLearning/enroll'
import { path } from 'src/constants/path'
import { getEnrollState } from '../events'
import { postUpdateProfile } from 'src/services/profile'
import {
  setCloseDialog,
  setOpenErrorDialog,
  setStopLoadingDialog,
} from '../../../../../redux/slices/profile'
import { normalizeUser } from 'src/utils/lib'

export const handleClickBack = (isVerification) => {
  if (isVerification) {
    const uuid = _.get(getEnrollState().data, 'uuid', '')
    window.location.href = `${path.eLearning}/course/${uuid}`
  } else {
    const activeStep = getEnrollState().activeStep
    store.dispatch(setStep(activeStep - 1))
  }
}

export const handleClickNext = () => {
  const activeStep = getEnrollState().activeStep
  store.dispatch(setStep(activeStep + 1))
}

export const handleDisableBtn = () => {
  const state = getEnrollState()
  const activeStep = state.activeStep
  const body = state.body
  if (activeStep === 0) return _.isNil(body.batch)
  if (activeStep === 1)
    return _.isNil(body.idCardImage) || _.isNil(body.faceImage)
}

export const handleUpdateProfile = () => async (dispatch) => {
  const enroll = store.getState().eLearningEnroll.body
  dispatch(startLoading())
  const { enrollFormError, duplicatedError } = await dispatch(checkDuplicate())
  dispatch(setReduxValue({ index: 'showFormError', value: true }))
  const enrollFormErrors = [
    ..._.get(enroll, 'enrollFormError', []),
    ...enrollFormError,
  ]
  const formError = _.get(enroll, 'formError', [])
  const errorCheck = _.find(enrollFormErrors, (ele) => {
    return ele
  })

  if (errorCheck) {
    let index = _.findIndex(formError, (ele) => {
      return !_.isEmpty(ele)
    })
    let element
    if (index >= 0) {
      element = document.getElementById(
        `${formError?.[index]?.[0]?.path}-${index}`
      )
    } else {
      index = _.findIndex(duplicatedError, (ele) => {
        return !_.isEmpty(ele)
      })
      element = document.getElementById(
        `${Object.keys(duplicatedError?.[index])?.[0]}-${index}`
      )
    }
    dispatch(stopLoading())
    if (element) {
      dispatch(
        openDialog({
          isCloseDialog: false,
          iconType: 'error',
          title: _.get(duplicatedError?.[0], 'title', 'ข้อมูลไม่ถูกต้อง'),
          message: [
            _.get(duplicatedError?.[0], 'value', 'กรุณาตรวจสอบข้อมูลอีกครั้ง'),
          ],
          buttonRight: {
            label: 'ตกลง',
            handleClick: () => {
              dispatch(closeDialog())
              element.scrollIntoView({
                behavior: 'smooth',
                block: 'center',
                inline: 'center',
              })
            },
          },
        })
      )
    }
    return { success: false, reason: 'validation-error' }
  } else {
    const enrollData = _.get(enroll, 'enroll', [])
    const users = enrollData.map((user) => {
      return {
        uuid: user.uuid,
        firstName: user.firstName,
        lastName: user.lastName,
        firstNameTH: user.firstNameTH,
        lastNameTH: user.lastNameTH,
        prefix: user.prefix,
        prefixTH: user.prefixTH,
        idCardNo: user.idCardNo,
        mobileNo: user.mobileNo,
        dateOfBirth: user.birthDate,
        email: user.email,
        type: user.type,
      }
    })
    const singleUser = users?.[0] || {}
    const res = await dispatch(postUpdateProfile(singleUser))
    const payload = _.get(res, 'payload', null)
    const isMobile = /Mobi|Android/i.test(navigator.userAgent)
    dispatch(setStopLoadingDialog())
    if (payload.data) {
      const userStr = localStorage.getItem('user')
      const user = userStr ? JSON.parse(userStr) : {}
      const updatedData = _.get(payload.data, 'updatedData', user)
      const normalizedUser = normalizeUser(updatedData)
      localStorage.setItem('user', JSON.stringify(normalizedUser))
      return { success: true, reason: 'updated-success' }
    } else {
      dispatch(stopLoading())
      const constraints = _.get(res?.meta?.response, 'data.constraints', {})
      if (constraints) {
        dispatch(
          setOpenErrorDialog({
            title: _.get(constraints, 'title', ''),
            message: [_.get(constraints, 'value', '')],
            buttonRight: {
              label: isMobile ? 'โทรหาเรา' : 'รับทราบ',
              handleClick: () => {
                if (isMobile) {
                  window.open = 'tel:1159' // ใช้โทรออก
                  dispatch(setCloseDialog())
                  dispatch(closeDialog())
                } else {
                  dispatch(setCloseDialog())
                  dispatch(closeDialog())
                }
              },
            },
          })
        )
        return { success: false, reason: 'server-validation-error' }
      }
    }
  }
  return { success: false, reason: 'unknown-error' }
}

const checkDuplicate = () => async (dispatch) => {
  const state = store.getState()
  const enroll = _.get(state.eLearningEnroll, 'body.enroll', [])
  let newEnrollFormError = [..._.get(state.enroll, 'enrollFormErrors', [])]

  // Get user type from localStorage to determine if we should check staff table
  const user = JSON.parse(window.localStorage.getItem('user') || '{}')
  const userType = user?.userType
  const staffType = _.get(user, 'staffProfile.type', null)
  const isStaffAcademy = userType === 'STAFF' && staffType !== 'NON_ACADEMY'
  const isStaffNonAcademy = userType === 'STAFF' && staffType === 'NON_ACADEMY'
  
  // For staff (both Academy and Non Academy), only check duplicates in staff table
  // Staff and Staff Non Academy are considered the same table
  const shouldCheckStaffOnly = isStaffAcademy || isStaffNonAcademy

  const users = enroll.map((user) => {
    return {
      uuid: user.uuid,
      idCardNo: user.idCardNo,
      mobileNo: user.mobileNo,
      type: shouldCheckStaffOnly ? 'STAFF' : user.type, // Force STAFF type for staff roles
    }
  })

  const result = await dispatch(checkDuplicateData({ users }))
  const checkUser = _.get(result, 'payload', '')

  let newDuplicatedError = []
  checkUser.map((ele, ind) => {
    let error = {}
    // Only check ID Card duplicate for staff roles (both Academy and Non Academy)
    if (shouldCheckStaffOnly && !ele.id) {
      newEnrollFormError[ind] = true
      error.idCardNo = 'หมายเลขบัตรตัวประชาชนนี้มีในระบบแล้ว'
      error.title = 'ท่านไม่สามารถใช้หมายเลขบัตรประชาชนของท่านได้'
      error.value =
        'กรุณาตรวจสอบหมายเลขบัตรประชาชนของท่านอีกครั้ง\nหรือ ติดต่อผู้จัดการของท่าน \nหรือ โทร 1159'
    }
    // Only check Phone duplicate for Staff Non Academy
    if (isStaffNonAcademy && !ele.mobile) {
      newEnrollFormError[ind] = true
      error.mobileNo = 'หมายเลขโทรศัพท์มือถือนี้มีในระบบแล้ว'
      error.title = 'ท่านไม่สามารถใช้หมายเลขโทรศัพท์มือถือนี้ได้'
      error.value =
        'หมายเลขโทรศัพท์มือถือของท่านถูกใช้งานแล้ว\n กรุณากรอกอีกครั้ง หากยังพบปัญหา\n กรุณาติดต่อสอบถามทีมงานดูแลตัวแทน'
    }
    // For non-staff roles, check both ID Card and Mobile
    if (!shouldCheckStaffOnly) {
      if (!ele.id) {
        newEnrollFormError[ind] = true
        error.idCardNo = 'หมายเลขบัตรตัวประชาชนนี้มีในระบบแล้ว'
        error.title = 'ท่านไม่สามารถใช้หมายเลขบัตรประชาชนของท่านได้'
        error.value =
          'กรุณาตรวจสอบหมายเลขบัตรประชาชนของท่านอีกครั้ง\nหรือ ติดต่อผู้จัดการของท่าน \nหรือ โทร 1159'
      }
      if (!ele.mobile) {
        newEnrollFormError[ind] = true
        error.mobileNo = 'หมายเลขโทรศัพท์มือถือนี้มีในระบบแล้ว'
        error.title = 'ท่านไม่สามารถใช้หมายเลขโทรศัพท์มือถือนี้ได้'
        error.value =
          'หมายเลขโทรศัพท์มือถือของท่านถูกใช้งานแล้ว\n กรุณากรอกอีกครั้ง หากยังพบปัญหา\n กรุณาติดต่อสอบถามทีมงานดูแลตัวแทน'
      }
    }
    newDuplicatedError.push(error)
  })
  dispatch(
    setReduxValue({ index: 'enrollFormError', value: newEnrollFormError })
  )
  dispatch(
    setReduxValue({ index: 'duplicatedError', value: newDuplicatedError })
  )
  return {
    enrollFormError: newEnrollFormError,
    duplicatedError: newDuplicatedError,
  }
}

export const handleSubmitEnroll = async () => {
  store.dispatch(startLoading())
  const updateProfile = await store.dispatch(handleUpdateProfile())
  if (updateProfile.success) {
    const state = getEnrollState()
    const body = {
      eLearningCourse: state.data,
      eLearningCourseBatch: state.body.batch,
    }
    const response = await store.dispatch(postEnrollCourse(body))
    if (_.isEmpty(response.error)) {
      handleEnrollSuccess(response)
    }
  }

  store.dispatch(stopLoading())
}

export const handleEnrollSuccess = (response) => {
  const { data, body } = getEnrollState()
  store.dispatch(
    openDialog({
      ...dialogContentObj,
      title: 'คุณยังเหลืออีก 1 ขั้นตอน',
      message: ['ขณะนี้ท่านสามารถยืนยันตัวตนเพื่อรับสิทธิ์เข้าอบรม'],
      buttonLeft: {
        label: 'ไว้ภายหลัง',
        handleClick: () => {
          store.dispatch(closeDialog())
          window.location.href = `/e-learning/course/${data.uuid}`
        },
      },
      buttonRight: {
        label: 'ยืนยันตัวตน',
        endIcon: <ArrowForwardOutlined />,
        handleClick: () => {
          store.dispatch(closeDialog())
          const batchLearnerUuid = _.get(response.payload, 'data.uuid', '')
          window.location.href = `${path.eLearningVerification}/${body.batch.uuid}?learner=${batchLearnerUuid}`
        },
      },
    })
  )
}
